import { DialogContent, DialogTitle, List, ListItem } from '@mui/material';
import { CampaignHistory as CampaignHistoryType } from '__generated__/queries-newsletter';
import moment from 'moment';
import { FC } from 'react';

interface CampaignHistoryProps {
  histories: CampaignHistoryType[];
}

export const CampaignHistory: FC<CampaignHistoryProps> = ({ histories }) => {
  return (
    <>
      <DialogTitle>Historique des modifications de la campagne</DialogTitle>
      <DialogContent>
        <List>
          {histories.map((history) => (
            <ListItem key={history.id}>
              Modifié par : {history.userName} le{' '}
              {moment(history.createdAt).format('D MMM YYYY, HH[h]mm')}
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </>
  );
};
